import React, { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useTheme } from 'react-native-paper'
import { observable } from 'mobx'
import { observer } from 'mobx-react-lite'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { referralRock } from '../../utils/types/urlQueryMapping'
import CommonInput from '../atoms/builder-2.0/CommonInput'

const externalReferralStore = observable.box('')
const referralCookie = referralRock.referralCode.cookieName

export const ReferralInput = observer(({ route, navigation, ...props }) => {
  const [cookies, setCookie] = useCookies(['user-type']),
    cookieValue = cookies[referralCookie],
    { textInactive } = useTheme()

  useEffect(() => {
    return () => {
      if (!cookieValue) {
        setCookie(referralCookie, externalReferralStore.get(), { path: '/' })
      }
    }
  }, [])

  return (
    <CommonInput
      testID="referalInput"
      label="Referal Code (If Applicable)"
      style={composeStyle(cookieValue && { color: textInactive })}
      disabled={cookieValue}
      value={cookieValue || externalReferralStore.get()}
      onChangeText={(e) => {
        externalReferralStore.set(e)
      }}
      {...props}
    />
  )
})
